import Controller from "@ember/controller"
import { computed, get } from "@ember/object"
import { inject as service } from "@ember/service"
import belongsTo from "cc-frontend/helpers/belongs-to"
import moment from "cc-frontend/utils/extended-moment"
import * as R from "remeda"
import findDocument from "../../helpers/find-document"

export default class CourseUnitsController extends Controller {
  @service("ember-store")
  store

  queryParams = [
    "startDate",
    "endDate",
    "unitId",
    "headerText",
    "showComments",
    "showStandardDescriptions",
    "isFilteringCards",
    "visibleCards",
    "shouldPrintOutline",
    "printUnits",
    "printUnitLessons",
  ]

  unitId = ""
  showComments = false
  showStandardDescriptions = true
  isFilteringCards = false
  visibleCards = []
  pageBreaks = "none"
  shouldPrintOutline = false

  @findDocument("model.courseId", "course") course

  @belongsTo("course", "planbook") planbook

  @belongsTo("planbook.content", "rotationCalendar") rotationCalendar

  get firstDateOfLessons() {
    let first = R.pipe(
      get(this, "course.content.attributes.calendar.dates"),
      R.filter((d) => d.type === "course-date-custom"),
      R.sortBy((d) => d.attributes.dateString),
      R.first
    )
    return first?.attributes.dateString
  }

  get lastDateOfLessons() {
    let last = R.pipe(
      get(this, "course.content.attributes.calendar.dates"),
      R.filter((d) => d.type === "course-date-custom"),
      R.sortBy((d) => d.attributes.dateString),
      R.last
    )
    return last?.attributes.dateString
  }

  @computed("startDate", "endDate", "rotationCalendar.content.attributes.schoolDays")
  get dateStrings() {
    let validSchoolDays = get(this, "rotationCalendar.content.attributes.schoolDays")

    let startDate = get(this, "startDate")
    let endDate = get(this, "endDate")

    let range = moment.range(startDate, endDate)
    let acc = []
    Array.from(range.by("days")).map((moment) => {
      if (validSchoolDays.includes(moment.weekday())) acc.push(moment)
    })
    let newDates = R.uniq(R.map(acc, (m) => m.format("YYYY-MM-DD")))

    return newDates
  }
}
